import React, {useState} from 'react';
import PropTypes from 'prop-types';
import SearchTermToggle from 'search/controls/SearchTermToggle';
import {useSelector} from 'react-redux';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import {Page} from 'page/utils';
import WithSearchControls from 'search/controls/WithSearchControls';
import SearchDateTimePickers from 'search/controls/SearchDateTimePickers';
import SearchInput from 'search/controls/SearchInput';
import Config from 'config';
import moment from 'moment';
import Breadcrumbs from 'common/breadcrumbs/Breadcrumbs';
import SearchActions from '../search/controls/SearchActions';
import {routeToSearch} from 'router/router-utils';

function SearchControls({
    timezone,
    isMobile,
    isAdmin,
    isMonthly,
    isSearching,
    isValidStart,
    starts: initialStarts,
    ends: initialEnds,
    searchString,
    searchBounds,
    pushTo,
    onInputChange,
    onDateTimeChange,
    onSubmit,
    currentSearch,
}) {
    const [location, setLocation] = useState(null);
    const [starts, setStarts] = useState(initialStarts);
    const [ends, setEnds] = useState(initialEnds);
    const {id: cityId, display_name: cityName, state} = useSelector(
        s => s.city.data
    );

    function onSearchDateTimeChange(evt) {
        const {start, end} = evt;

        setStarts(moment(start).format(Config.apiDateTimeFormat));
        setEnds(moment(end).format(Config.apiDateTimeFormat));

        onDateTimeChange(evt);
    }

    function onSearchButtonClick() {
        if (isEmpty(currentSearch) && isNil(location)) {
            routeToSearch({
                method: pushTo,
                pageType: Page.CITY,
                id: cityId,
                queryParams: {
                    monthly: isMonthly,
                    starts,
                    ...(!isMonthly && {ends}),
                },
            });
        } else if (!isNil(location)) {
            onSubmit(location, false, true);
        }
    }

    function onInputSubmit(locationData) {
        setLocation(locationData);
    }

    return (
        <div className="MidFunnel-search-controls">
            <Breadcrumbs
                className="MidFunnel-breadcrumbs"
                items={[
                    {link: '/cities', label: 'Cities'},
                    {label: `${cityName}, ${state}`, active: true},
                ]}
            />

            <h1>
                {cityName} {isMonthly ? 'Monthly ' : ''}Parking
            </h1>

            <SearchTermToggle isSearching={isSearching} />

            <SearchInput
                isMonthly={isMonthly}
                isSearching={isSearching}
                searchString={searchString}
                searchBounds={searchBounds}
                onChange={onInputChange}
                onSubmit={onInputSubmit}
            />

            <SearchDateTimePickers
                timezone={timezone}
                isAdmin={isAdmin}
                isMonthly={isMonthly}
                starts={initialStarts}
                ends={initialEnds}
                onChange={onSearchDateTimeChange}
            />

            <SearchActions
                addKeyListeners={!isMobile}
                isSearching={isSearching}
                isValidStart={isValidStart}
                onSearchClick={onSearchButtonClick}
            />
        </div>
    );
}

SearchControls.propTypes = {
    timezone: PropTypes.string.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isMonthly: PropTypes.bool.isRequired,
    isSearching: PropTypes.bool,
    isValidStart: PropTypes.bool,
    starts: PropTypes.string,
    ends: PropTypes.string,
    searchString: PropTypes.string,
    searchBounds: PropTypes.any,
    pushTo: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onDateTimeChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    currentSearch: PropTypes.string,
};

export default WithSearchControls(SearchControls);
